export type WarehouseETAGridDetails = {
  centralFlag?: boolean | false;
  eTShipmenttext: string;
  eta: string;
  onDemandFlag?: boolean;
  quantity: string;
  reservedQuantity?: string;
  stockStatues: string;
  stockStatus: string;
  stockStatusDisplayFlag: boolean;
  warehouseName: string;
};

export const getDate = (date: string) => {
  const date1 = date.split(' - ');
  let finalDate = null;
  if (date1.length > 1) {
    const [year, month, day] = date1[0].split('-');
    const dt1 = `${day}/${month}/${year}`;

    const [year1, month1, day1] = date1[1].split('-');
    const dt2 = `${day1}/${month1}/${year1}`;

    finalDate = `${dt1} - ${dt2}`;
  } else {
    const [year, month, day] = date.split('-');
    finalDate = `${day}/${month}/${year}`;
  }

  return finalDate;
};

export type WarehouseETARequest = {
  Products: Products[];
  getReserveAvailablity: boolean;
};

export type Products = {
  ingramPartNumber: string;
};

export const getDateZenithOld = (date: string) => {
  const date1 = new Date(date);
  const [, , day] = date.split('-');
  const days = day;
  const months = date1.toLocaleString('default', { month: 'short' });
  //const years = date1.toLocaleString('default', { year: 'numeric' });
  return `${months} ${days}`;
};

export const getDateZenith = (date: string) => {
  const date1 = date.split(' - ');
  let finalDate = null;
  if (date1.length > 1) {
    const [year, month, day] = date1[0].split('-');
    const dt1 = `${day}.${month}.${year}`;

    const [year1, month1, day1] = date1[1].split('-');
    const dt2 = `${day1}.${month1}.${year1}`;

    finalDate = `${dt1} - ${dt2}`;
  } else {
    const [year, month, day] = date.split('-');
    finalDate = `${day}.${month}.${year}`;
  }

  return finalDate;
};

export const getDateZenithUS = (date: string, siteCode?: string) => {
  const date1 = date.split(' - ');
  let finalDate = null;
  if (date1.length > 1) {
    const [year, month, day] = date1[0].split('-');
    const dt1 =
      siteCode === 'ca' ? `${month}/${day}/${year}` : `${month}.${day}.${year}`;

    const [year1, month1, day1] = date1[1].split('-');
    const dt2 =
      siteCode === 'ca'
        ? `${month1}/${day1}/${year1}`
        : `${month1}.${day1}.${year1}`;

    finalDate = `${dt1} - ${dt2}`;
  } else {
    const [year, month, day] = date.split('-');
    finalDate =
      siteCode === 'ca' ? `${month}/${day}/${year}` : `${month}.${day}.${year}`;
  }

  return finalDate;
};
